import "./Level12.scss";

export default function Level1() {
  return (
    <div className="level12__container">
      <div className="level12__puzzle">
        <div className="level12__file">
          <p className="level12__letter">A</p>
          <p className="level12__clue">I</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">B</p>
          <p className="level12__clue">H</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">C</p>
          <p className="level12__clue">G</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">D</p>
          <p className="level12__clue">F</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">E</p>
          <p className="level12__clue">E</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">F</p>
          <p className="level12__clue">D</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">G</p>
          <p className="level12__clue">C</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">H</p>
          <p className="level12__clue">B</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">I</p>
          <p className="level12__clue">A</p>
        </div>
      </div>

      <div className="level12__puzzle">
        <div className="level12__file">
          <p className="level12__letter">J</p>
          <p className="level12__clue">R</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">K</p>
          <p className="level12__clue">Q</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">L</p>
          <p className="level12__clue">P</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">M</p>
          <p className="level12__clue">O</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">N</p>
          <p className="level12__clue">N</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">O</p>
          <p className="level12__clue">M</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">P</p>
          <p className="level12__clue">L</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">Q</p>
          <p className="level12__clue">K</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">R</p>
          <p className="level12__clue">J</p>
        </div>
      </div>

      <div className="level12__puzzle">
        <div className="level12__file">
          <p className="level12__letter">S</p>
          <p className="level12__clue">Z</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">T</p>
          <p className="level12__clue">Y</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">U</p>
          <p className="level12__clue">X</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">V</p>
          <p className="level12__clue">W</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">W</p>
          <p className="level12__clue">V</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">X</p>
          <p className="level12__clue">U</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">Y</p>
          <p className="level12__clue">T</p>
        </div>
        <div className="level12__file">
          <p className="level12__letter">Z</p>
          <p className="level12__clue">S</p>
        </div>
      </div>

      <div className="level12__guess-container">
        <span className="level12__guess">
          NXOEJM &nbsp; FEP &nbsp; NAWEP
        </span>
      </div>
    </div>
  );
}
